import { render, staticRenderFns } from "./Side-Home-Dynamic-Group.vue?vue&type=template&id=be40cd7a"
import script from "./Side-Home-Dynamic-Group.vue?vue&type=script&lang=js"
export * from "./Side-Home-Dynamic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports